import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { compare } from 'src/app/globals';
import { IOffersProviderService, OFFERS_PROVIDER_SERVICE } from 'src/app/lib/shared/interfaces';
import { Offer } from 'src/app/lib/offer/classes';

@Component({
  selector: 'app-offer-widget',
  templateUrl: './offer-widget.component.html',
  styleUrls: ['./offer-widget.component.css']
})
export class OfferWidgetComponent implements OnDestroy, OnInit {

  @Output() offerClicked: EventEmitter<Offer> = new EventEmitter();

  dataSource: MatTableDataSource<Offer> = new MatTableDataSource();

  columns: string[] = ['number', 'title', 'status', 'itemCount', 'options'];

  _subscriptions: Subscription[] = [];

  constructor(
    @Inject(OFFERS_PROVIDER_SERVICE) public service: IOffersProviderService,
    private _router: Router
  ) { }

  navigateToOfferDetails = (offer: Offer) => this._router.navigate(['/offer-details', offer.offerid]);

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(this.service.offers$.subscribe((offers) => {
      this.dataSource.data = offers as any;
    }));
  }

  sortData(sort: Sort) {
    this.dataSource.data.sort((a, b) => {
      switch (sort.active) {
        case 'offeritem':
          return compare(Array.isArray(a.offeritem)? a.offeritem.length: 0, Array.isArray(b.offeritem)? b.offeritem.length: 0, sort.direction === 'asc');

        default:
          return compare(a[sort.active], b[sort.active], sort.direction === 'asc');
      }
    });
  }

  triggerOfferClick(offer: Offer) {
    this.offerClicked.next(offer);
  }

}
